<template>
  <div class="general-tab">
    <div v-if="!hasWindingAmount">
      <s-empty-list/>
    </div>
    <div v-else class="general-tab__winding-sections">
      <div
        v-for="(winding, index) in tabInfo.windingAmount"
        class="mb-2"
        :key="renderKey + index"
      >
        <winding-section
          :winding="windingsData[index + 1]"
          :winding-id="index + 1"
          :loading="loadingWindings[index + 1]"
        />
      </div>
    </div>
    <final-temperature-section
      :final-temperature-charts="finalTemperatureCharts"
      :winding-amount="tabInfo.windingAmount"
      :loading="loadingFinalTemperatureCharts"
    />
  </div>
</template>

<script>
import eventBus from '@/services/globalEventBus';
import engineeringEvents from '@/domain/events/engineering';
import Service
  from '@/domain/services/installation/engineering/finalGradient/finalGradientService';
import FinalTemperatureSection
  from '@/domain/components/installation/engineering/finalGradient/FinalTemperatureSection';
import WindingSection from '@/domain/components/installation/engineering/finalGradient/WindingSection';

export default {
  name: 'FinalGradientGeneralTab',
  props: {
    tabInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    FinalTemperatureSection,
    WindingSection,
  },
  data: () => ({
    renderKey: 0,
    finalTemperatureCharts: [],
    loadingFinalTemperatureCharts: false,
    windingsData: [],
    loadingWindings: [],
  }),
  computed: {
    hasWindingAmount() {
      const { windingAmount } = this.tabInfo;
      return windingAmount > 0;
    },
    assetModuleId() {
      const { assetModuleId } = this.$route.params;
      return assetModuleId;
    },
  },
  created() {
    this.init();
    this.refreshData(true);
  },
  beforeDestroy() {
    this.deinit();
  },
  methods: {
    init() {
      eventBus.on(engineeringEvents.refreshDataTab, this.refreshDataEvent, this);
    },
    deinit() {
      eventBus.off(engineeringEvents.refreshDataTab, this.refreshDataEvent, this);
    },
    updateRenderKey() {
      this.renderKey += 1;
    },
    getExpectedFinalTemperature(showLoading = false) {
      this.loadingFinalTemperatureCharts = showLoading;
      Service.getExpectedFinalTemperature(this.assetModuleId)
        .then((response) => {
          this.finalTemperatureCharts = response;
        })
        .finally(() => {
          this.loadingFinalTemperatureCharts = false;
        });
    },
    getWinding(showLoading, windingId) {
      const { assetModuleId } = this.$route.params;
      this.loadingWindings[windingId] = showLoading;

      Service.getWinding(assetModuleId, windingId)
        .then((response) => {
          this.windingsData[windingId] = response;
        })
        .finally(() => {
          this.loadingWindings[windingId] = false;
          this.updateRenderKey();
        });
    },
    getWindingsByWindingsAmount(showLoading = false) {
      const { windingAmount } = this.tabInfo;
      for (let index = 1; index <= windingAmount; index += 1) {
        this.getWinding(showLoading, index);
      }
    },
    refreshData(showLoading = false) {
      if (!this.tabInfo.windingAmount) return;

      this.getExpectedFinalTemperature(showLoading);
      this.getWindingsByWindingsAmount(showLoading);
    },
    refreshDataEvent(showLoading = false) {
      this.refreshData(showLoading);
    },
  },
};
</script>

<style lang="sass" scoped>
.general-tab
  page-break-after: always
</style>
